import { render, staticRenderFns } from "./informacionBono.vue?vue&type=template&id=2ef8e124&scoped=true&"
import script from "./informacionBono.vue?vue&type=script&lang=js&"
export * from "./informacionBono.vue?vue&type=script&lang=js&"
import style0 from "./informacionBono.vue?vue&type=style&index=0&id=2ef8e124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef8e124",
  null
  
)

export default component.exports